import {
  createNotificationWithPrintListener,
  closeNotification
} from 'screens/Applications&WorkOrders/Components/Notification/genericNotification';
import {
  NotificationType,
  NOTIFICATION_CONFIG
} from 'screens/Applications&WorkOrders/Components/Notification/notificationConstants';
import './index.css';
import NOTIFICATION_STRINGS from './Constants/notificationString';

export const CREATE_SUCCESS_KEY = 'application-create-success';
export const CREATE_CLASSNAME_PREFIX = 'application-creation';

let applicationSavedTimerHandle: ReturnType<typeof setTimeout> | null = null;

// Resume the normal disappear timer rather than closing immediately.
// Cancels any previous pending timer so rapid re-calls don't stack.
export const resumeApplicationSavedNotificationTimer = () => {
  if (applicationSavedTimerHandle !== null) {
    clearTimeout(applicationSavedTimerHandle);
  }
  applicationSavedTimerHandle = setTimeout(() => {
    applicationSavedTimerHandle = null;
    closeNotification(CREATE_CLASSNAME_PREFIX);
  }, NOTIFICATION_CONFIG.DURATION * 1000);
};

interface ApplicationNotificationOptions {
  onDuplicate?: () => void;
  onPrint?: () => void;
  onRetry?: () => void;
}

const applicationNotification = (
  type:
    | 'CREATE_SUCCESS'
    | 'EDIT_SUCCESS'
    | 'CREATE_OR_EDIT_ERROR'
    | 'DELETE_SUCCESS'
    | 'DELETE_ERROR'
    | 'PDF_EXPORT_ERROR',
  onClose: () => void = () => {},
  options?: ApplicationNotificationOptions
) => {
  const notificationType: NotificationType = type as NotificationType;

  const notificationStrings = {
    SAVED: NOTIFICATION_STRINGS.APPLICATION_SAVED,
    UPDATED: NOTIFICATION_STRINGS.APPLICATION_UPDATED,
    DELETED: NOTIFICATION_STRINGS.APPLICATION_DELETED,
    DUPLICATE_BUTTON: NOTIFICATION_STRINGS.DUPLICATE_BUTTON,
    PRINT_PDF_BUTTON: NOTIFICATION_STRINGS.PRINT_PDF_BUTTON,
    ERROR_TITLE: NOTIFICATION_STRINGS.ERROR_TITLE,
    ERROR_MESSAGE: NOTIFICATION_STRINGS.ERROR_MESSAGE,
    DELETE_ERROR_TITLE: NOTIFICATION_STRINGS.DELETE_ERROR_TITLE,
    DELETE_ERROR_MESSAGE: NOTIFICATION_STRINGS.DELETE_ERROR_MESSAGE,
    CONTACT_BUTTON: NOTIFICATION_STRINGS.CONTACT_BUTTON,
    PDF_ERROR_TITLE: NOTIFICATION_STRINGS.PDF_ERROR_TITLE,
    PDF_ERROR_MESSAGE: NOTIFICATION_STRINGS.PDF_ERROR_MESSAGE,
    PDF_TRY_AGAIN_BUTTON: NOTIFICATION_STRINGS.PDF_TRY_AGAIN_BUTTON
  };

  createNotificationWithPrintListener(
    notificationType,
    notificationStrings,
    CREATE_SUCCESS_KEY,
    CREATE_CLASSNAME_PREFIX,
    {
      onDuplicate: options?.onDuplicate,
      onPrint: options?.onPrint,
      onRetry: options?.onRetry,
      onClose
    }
  );
};

export default applicationNotification;
